import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { Store } from '@ngrx/store';

import {
  fetchServiceRequests,
  selectServiceRequests,
  selectServiceRequestsFetchedAt,
} from '@state/service-request';
import { RecreateServiceRequestDialog } from 'src/app/components/recreate-service-request-dialog/recreate-service-request.dialog';
import { ServiceRequestsTableComponent } from 'src/app/components/service-requests-table/service-requests-table.component';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    ServiceRequestsTableComponent,
  ],
  templateUrl: './service-requests.page.html',
  styleUrl: './service-requests.page.scss',
})
export class ServiceRequestsPage implements OnInit {
  readonly dialog = inject(MatDialog);
  
  $serviceRequests = this.store.select(selectServiceRequests);
  $serviceRequestsFetchedAt = this.store.select(selectServiceRequestsFetchedAt);

  constructor(private store: Store) {}

  public ngOnInit(): void {
    this.store.dispatch(fetchServiceRequests());
  }

  public onRecreateServiceRequest(): void {
    const dialogRef = this.dialog.open(RecreateServiceRequestDialog, {
      width: '800px',
      maxHeight: '90vh',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        // Refresh the service requests list
        this.store.dispatch(fetchServiceRequests());
      }
    });
  }
}
